import type { ListOption } from '../GenericBloc/GenericShortListFilter/GenericShortListDropdown';

export enum OS_TYPE {
  WINDOWS = 'Windows',
  MAC = 'Mac',
  LINUX = 'Linux',
  UBUNTU = 'Ubuntu',
  ANDROID = 'Android',
  IOS = 'iOS',
}

export const OS_FILTER_OPTIONS: ListOption<OS_TYPE>[] = [
  { value: OS_TYPE.WINDOWS, label: 'Windows', icon: 'windows' },
  { value: OS_TYPE.MAC, label: 'macOS', icon: 'apple' },
  { value: OS_TYPE.LINUX, label: 'Linux', icon: 'linux' },
  { value: OS_TYPE.UBUNTU, label: 'Ubuntu', icon: 'ubuntu' },
  { value: OS_TYPE.ANDROID, label: 'Android', icon: 'android' },
  { value: OS_TYPE.IOS, label: 'iOS', icon: 'apple' },
];
